import { chooseReadingContext } from './movement-state.js';

export function createReadingContext(context) {
  let visible={}, held=null, audio=null, manual=false, timer, lastKey='', original=null;
  const listeners=new Set();
  function current(){return chooseReadingContext({held:held?{...visible,...held}:null,audio,visible,manual});}
  function publish(){const value=current(),key=JSON.stringify(value);if(key===lastKey)return;lastKey=key;listeners.forEach(fn=>fn(value));}
  function update(){
    // Modal focus/scroll restoration must not move the prayer being discussed.
    if(document.querySelector('dialog[open]')) return;
    const base=context.reading();
    if(!base?.sectionId){visible={};held=null;audio=null;original=null;publish();return;}
    if(visible.sectionId && visible.sectionId!==base.sectionId){held=null;audio=null;original=null;manual=false;}
    if(held&&Array.isArray(base.visibleBlockIds)&&!base.visibleBlockIds.includes(held.blockId))held=null;
    if(document.querySelector('.classic-original-reader')) {
      visible={...base,...original,mapped:original?.mapped===true};publish();return;
    }
    const top=(document.getElementById('topbar')?.getBoundingClientRect().bottom||0)+24;
    const bottom=Math.min(innerHeight,document.getElementById('reader-nav')?.getBoundingClientRect().top||innerHeight);
    const root=document.querySelector(`[data-reader-section="${CSS.escape(base.sectionId)}"]`)||document;
    const nodes=[...root.querySelectorAll('.prayer-content [data-prayer-block]')].filter(node=>{
      const r=node.getBoundingClientRect();return r.height>0&&r.bottom>top&&r.top<bottom&&getComputedStyle(node).visibility!=='hidden';
    });
    const node=nodes.reduce((best,node)=>!best||Math.abs(Math.max(0,node.getBoundingClientRect().top-top))<Math.abs(Math.max(0,best.getBoundingClientRect().top-top))?node:best,null);
    visible={...base,blockId:node?.dataset.prayerBlock||null,mapped:!!node};publish();
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(update,110);}
  function browse(event){if(event.target?.closest?.('dialog,.audio-player,#topbar'))return;manual=true;audio=null;schedule();}
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('wheel',browse,{passive:true});
  window.addEventListener('touchmove',browse,{passive:true});
  window.addEventListener('keydown',event=>{if(['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key))browse(event);});
  window.addEventListener('siddur-audio-position',event=>{audio=event.detail;if(audio?.resumedFollow)manual=false;publish();});
  window.addEventListener('siddur-original-position',event=>{original=event.detail;schedule();});
  new MutationObserver(schedule).observe(document.getElementById('app'),{childList:true,subtree:true});
  return {
    subscribe(fn){listeners.add(fn);fn(current());return()=>listeners.delete(fn);},
    update:schedule,
    hold(){const point=current();if(point.blockId)held={sectionId:point.sectionId,blockId:point.blockId,phraseId:point.phraseId,precision:point.precision,mapped:point.mapped};publish();},
    here(blockId){const base=context.reading();if(base?.visibleBlockIds?.includes(blockId)){held={sectionId:base.sectionId,blockId,mapped:true,precision:'passage'};publish();}},
    resume(){held=null;manual=false;publish();update();},
    current,
  };
}
